import { render } from "./Webhooks.vue?vue&type=template&id=51febb9f&scoped=true"
import script from "./Webhooks.vue?vue&type=script&lang=js"
export * from "./Webhooks.vue?vue&type=script&lang=js"

import "./Webhooks.vue?vue&type=style&index=0&id=51febb9f&lang=scss"
import "./Webhooks.vue?vue&type=style&index=1&id=51febb9f&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51febb9f"]])

export default __exports__